// extracted by mini-css-extract-plugin
module.exports = {"ProductSection":"ProductSection_ProductSection__3kr-Q"};